import React from "react";
import { Link } from "react-router-dom";
import { LOGO_SRC } from "../constants/brand";

const FEATURES = [
  {
    title: "Live availability",
    desc: "See garages, street parking, and partner lots near you in real time—fewer loops around the block.",
    icon: "map",
  },
  {
    title: "Smart search",
    desc: "Filter by price, distance, EV charging, accessibility, and hours so you only see spots that fit your trip.",
    icon: "search",
  },
  {
    title: "Book with confidence",
    desc: "Clear pricing, simple booking flow, and support when you need it—parking that feels as calm as the destination.",
    icon: "shield",
  },
];

function FeatureIcon({ name }) {
  const common = {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };
  if (name === "map") {
    return (
      <svg {...common}>
        <path
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
          fill="currentColor"
        />
      </svg>
    );
  }
  if (name === "search") {
    return (
      <svg {...common}>
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          fill="currentColor"
        />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path
        d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Home() {
  return (
    <div className="home">
      <section className="home-hero" aria-labelledby="home-hero-heading">
        <div className="home-hero__aurora" aria-hidden />
        <div className="home-hero__grid" aria-hidden />
        <div className="home-hero__inner">
          <img
            src={LOGO_SRC}
            alt="ChillnPark"
            className="home-hero__logo"
            width={220}
            height={46}
          />
          <p className="home-hero__eyebrow">Parking spot finder</p>
          <h1 id="home-hero-heading" className="home-hero__title">
            Find parking.
            <span className="home-hero__title-accent"> Stay chill.</span>
          </h1>
          <p className="home-hero__lead">
            ChillnPark helps you discover available spaces around you—garages,
            lots, and street options—so you spend less time circling and more
            time enjoying where you&apos;re going.
          </p>
          <p className="home-hero__tagline">Parking made to chill.</p>
          <div className="home-hero__actions">
            <Link to="/support" className="btn btn-hero-primary">
              Get support
            </Link>
            <Link to="/privacy_policy" className="btn btn-hero-ghost">
              Privacy policy
            </Link>
          </div>
        </div>
      </section>

      <section className="home-features" aria-labelledby="features-heading">
        <div className="home-features__inner">
          <div className="home-features__intro">
            <h2 id="features-heading" className="home-features__heading">
              Built for drivers who value their time
            </h2>
            <p className="home-features__sub">
              Everything you need from a modern parking spot finder—clear
              information, powerful filters, and a calm experience from search
              to arrival.
            </p>
          </div>
          <ul className="home-feature-grid">
            {FEATURES.map((f) => (
              <li key={f.title} className="home-feature-card">
                <div className="home-feature-card__icon-wrap">
                  <FeatureIcon name={f.icon} />
                </div>
                <h3 className="home-feature-card__title">{f.title}</h3>
                <p className="home-feature-card__desc">{f.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="home-cta-band" aria-label="Closing note">
        <div className="home-cta-band__inner">
          <p className="home-cta-band__text">
            Whether you&apos;re commuting, running errands, or heading out for
            the evening—open the app, pick a spot, and roll in relaxed.
          </p>
        </div>
      </section>
    </div>
  );
}
